import { useCity } from '../CitiesProvider/CitiesProvider';
import { clsx } from 'clsx';
import * as styles from './styles.css';

export interface IChipProps {
  children: string;
  theme?: 'default' | 'green';
}

export const Chip = ({ children, theme = 'default' }: IChipProps) => {
  const { activeCity, setActiveCity } = useCity();
  const isActive = activeCity === children;

  return (
    <button
      className={clsx(styles['chip'], styles[`chip_theme_${theme}`], isActive && styles['chip_active'])}
      onClick={() => setActiveCity(children)}
    >
      {children}
    </button>
  );
};
